export default __webpack_public_path__ + "static/media/addFile.fd64d781.svg";